<template>
  <div v-if="visible" class="page-loading">
    <div class="loading-content">
      <div class="loading-spinner">
        <div class="spinner-ring"></div>
      </div>
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * 页面加载组件
 * 使用绝对定位，不依赖flex布局，跟随系统主题配色
 * @author AI Assistant
 * @date 2024
 */

interface Props {
  visible?: boolean
  text?: string
}

const props = withDefaults(defineProps<Props>(), {
  visible: true,
  text: '页面加载中...'
})
</script>

<style scoped>
.page-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--el-bg-color);
  z-index: 9999;
  transition: opacity 0.3s ease;
}

.loading-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.loading-spinner {
  margin-bottom: 16px;
}

.spinner-ring {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 3px solid var(--el-border-color-light);
  border-radius: 50%;
  border-top-color: var(--el-color-primary);
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: var(--el-text-color-primary);
  font-size: 14px;
  line-height: 1.5;
}

/* 深色模式适配 */
@media (prefers-color-scheme: dark) {
  .page-loading {
    background-color: var(--el-bg-color, #1a1a1a);
  }

  .loading-text {
    color: var(--el-text-color-primary, #e5eaf3);
  }

  .spinner-ring {
    border-color: var(--el-border-color-light, #414243);
    border-top-color: var(--el-color-primary, #409eff);
  }
}
</style>
